import { apiClient } from "./apiClient";

// Edge listesini getir (role'e göre filtrelenmiş)
export async function getEdges(accessToken, tenantId = null) {
  const params = tenantId ? { tenant_id: tenantId } : {};
  const res = await apiClient.get("/edges/list", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  const data = res.data;
  return data.items || data;
}

// Tek bir edge getir (DB id ile)
export async function getEdgeById(accessToken, edgeDbId) {
  const res = await apiClient.get(`/edges/${edgeDbId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge'in alarm event geçmişi (Edge.open_alarm_count'un kaynağı, ayrı bir sistem --
// /metrics/alarms/{edgeId} InfluxDB'deki edge-pushed alarm measurement'ı döner, bu değil)
export async function getEdgeAlarmEvents(accessToken, edgeDbId) {
  const res = await apiClient.get(`/edges/${edgeDbId}/alarm-events`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Bir alarm event'ini elle kapat (auto-resolve her field için garanti değil)
export async function ackAlarmEvent(accessToken, edgeDbId, eventId) {
  const res = await apiClient.post(
    `/edges/${edgeDbId}/alarm-events/${eventId}/ack`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

// Edge'in yüklediği olay özetleri + danışman (yalnızca öneri) teşhis
export async function getEdgeIncidents(accessToken, edgeDbId) {
  const res = await apiClient.get(`/edges/${edgeDbId}/incidents`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

export async function getEdgeIncident(accessToken, edgeDbId, incidentPk) {
  const res = await apiClient.get(`/edges/${edgeDbId}/incidents/${incidentPk}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// İnsanın koyduğu kök neden etiketi: filo öğrenmesinin tek girişi
export async function labelEdgeIncident(accessToken, edgeDbId, incidentPk, rootCause, fixApplied) {
  const res = await apiClient.put(
    `/edges/${edgeDbId}/incidents/${incidentPk}/label`,
    { root_cause: rootCause, fix_applied: fixApplied || null },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

// Superadmin: tek olayı (ya da edge'in başarısız / günlük sınıra takılan hepsini) teşhis kuyruğuna geri koy
export async function rediagnoseEdgeIncident(accessToken, edgeDbId, incidentPk = null) {
  const url = incidentPk ? `/edges/${edgeDbId}/incidents/${incidentPk}/diagnose` : `/edges/${edgeDbId}/incidents/rediagnose`;
  const res = await apiClient.post(url, {}, { headers: { Authorization: `Bearer ${accessToken}` } });
  return res.data;
}

// Edge getir (edgeId ile - örn: EDGE-TR-001)
export async function getEdgeByEdgeId(accessToken, edgeId) {
  const res = await apiClient.get(`/edges/by-edgeid/${encodeURIComponent(edgeId)}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Yeni edge kaydet
export async function registerEdge(accessToken, tenantId, edgeData) {
  const res = await apiClient.post(`/edges/register/${tenantId}`, edgeData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge güncelle
export async function updateEdge(accessToken, edgeDbId, edgeData) {
  const res = await apiClient.put(`/edges/${edgeDbId}`, edgeData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge'in cloud telemetry opt-in ayarını güncelle
export async function setEdgeCloudTransfer(accessToken, edgeDbId, enabled) {
  const res = await apiClient.patch(
    `/edges/${edgeDbId}/cloud-transfer`,
    { enabled },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

// Edge Lite/Pro runtime tier
export async function setEdgeTier(accessToken, edgeDbId, tier) {
  const res = await apiClient.patch(
    `/edges/${edgeDbId}/tier`,
    { tier },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

// Edge sil
export async function deleteEdge(accessToken, edgeDbId) {
  const res = await apiClient.delete(`/edges/${edgeDbId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge için 15 dakika geçerli, tek kullanımlık enrollment claim'i üret.
export async function issueDeviceClaim(accessToken, edgeDbId) {
  const res = await apiClient.post(
    `/edges/${edgeDbId}/enrollment-claims`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

// Seçili edge'leri toplu olarak bir lokasyona taşır (locationId=null -> Lokasyonsuz).
export async function bulkMoveEdges(accessToken, edgeIds, locationId) {
  const res = await apiClient.post(
    `/edges/bulk-move`,
    { edge_ids: edgeIds, location_id: locationId },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

// Location subtree summary: {tenants:[...], locations:[...]} (counts per tenant / location).
export async function getEdgesSummary(accessToken, tenantId = null) {
  const res = await apiClient.get("/edges/summary", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params: tenantId ? { tenant_id: tenantId } : {},
  });
  return res.data;
}

// Paginated/filtered edge list -> {items, total} (total from X-Total-Count).
export async function listEdges(accessToken, params = {}) {
  const res = await apiClient.get("/edges/list", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  const items = Array.isArray(res.data) ? res.data : res.data.items || [];
  const hdr = res.headers?.["x-total-count"];
  return { items, total: Number(res.data.total ?? hdr ?? items.length) };
}
